







































import { Component, Vue } from "vue-property-decorator";
import {
  TimelineVisibleArea,
  localiseTimelineVisibleArea,
} from "@/data/models/TimelineSettings";

import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import DatePicker from "@/components/common/DatePicker.vue";
import { SchedulingModule } from "@/store/modules/SchedulingModule";
import { firestore } from "firebase";

@Component({
  components: {
    "date-picker": DatePicker,
    picker: PickerDialogComponent,
  },
})
export default class TimelineSettingsComponent extends Vue {
  visibleAreaOptions = [
    TimelineVisibleArea.ONE_DAY,
    TimelineVisibleArea.ONE_WEEK,
    TimelineVisibleArea.TWO_WEEKS,
    TimelineVisibleArea.FOUR_WEEKS,
  ];

  get onlyShowWorkingHours() {
    return SchedulingModule.timelineSettings.onlyShowWorkingHours;
  }

  set onlyShowWorkingHours(onlyShowWorkingHours: boolean) {
    SchedulingModule.setTimelineSettings({
      ...SchedulingModule.timelineSettings,
      onlyShowWorkingHours,
    });
  }

  get hideWeekends() {
    return !SchedulingModule.timelineSettings.showWeekends;
  }

  set hideWeekends(hideWeekends: boolean) {
    SchedulingModule.setTimelineSettings({
      ...SchedulingModule.timelineSettings,
      showWeekends: !hideWeekends,
    });
  }

  get visibleArea() {
    return SchedulingModule.timelineSettings.visibleArea;
  }

  set visibleArea(visibleArea: TimelineVisibleArea) {
    const currentSettings = SchedulingModule.timelineSettings;
    const focusedTaskStartDate = SchedulingModule.focusedTask?.startDate;

    SchedulingModule.setTimelineSettings({
      ...currentSettings,
      visibleArea,
      startDate:
        visibleArea == TimelineVisibleArea.ONE_WEEK
          ? currentSettings.startDate
          : focusedTaskStartDate ?? currentSettings.startDate,
    });
  }

  get startTimestamp() {
    return firestore.Timestamp.fromDate(
      SchedulingModule.timelineSettings.startDate
    );
  }

  set startTimestamp(timestamp: firestore.Timestamp) {
    SchedulingModule.setTimelineSettings({
      ...SchedulingModule.timelineSettings,
      startDate: timestamp.toDate(),
    });
  }

  onShowToday() {
    SchedulingModule.setTimelineSettings({
      ...SchedulingModule.timelineSettings,
      startDate: new Date(),
    });
  }

  localiseTimelineVisibleArea(timelineVisibleArea: TimelineVisibleArea) {
    return localiseTimelineVisibleArea(this, timelineVisibleArea);
  }
}
